import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOutlinerEyeClosed = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.05625 12.2983C3.78674 13.9855 5.02672 15.428 6.61896 16.4431C8.21121 17.4581 10.084 18 12 18C13.916 18 15.7888 17.4581 17.381 16.4431C18.9733 15.428 20.2133 13.9855 20.9437 12.2983",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgOutlinerEyeClosed);
export { ForwardRef as ReactComponent };
